import { render, staticRenderFns } from "./accordion-link.vue?vue&type=template&id=0df9b359&scoped=true"
import script from "./accordion-link.vue?vue&type=script&lang=js"
export * from "./accordion-link.vue?vue&type=script&lang=js"
import style0 from "./accordion-link.vue?vue&type=style&index=0&id=0df9b359&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df9b359",
  null
  
)

export default component.exports